"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListState = exports.listStateReducer = exports.caseInsensitiveFilter = exports.setFilterQueryReducer = exports.setPageNumberReducer = exports.setPageSizeReducer = exports.setSortKeyAndReverseIfSameKeyReducer = exports.getDefaultState = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const react_1 = require("react");

const types_1 = require("../types");

const getDefaultState = (options = {}) => {
  var _a, _b, _c, _d, _e, _f, _g;

  return {
    filterQuery: (_a = options.filterQuery) !== null && _a !== void 0 ? _a : '',
    filterQueryKeys: (_b = options.filterQueryKeys) !== null && _b !== void 0 ? _b : [],
    filterQueryMinLength: (_c = options.filterQueryMinLength) !== null && _c !== void 0 ? _c : 3,
    pageNumber: (_d = options.pageNumber) !== null && _d !== void 0 ? _d : 1,
    pageSize: (_e = options.pageSize) !== null && _e !== void 0 ? _e : types_1.MODEL_LIST_CONSTANTS.LIST_DEFAULT_PAGE_SIZE,
    sortKey: (_f = options.sortKey) !== null && _f !== void 0 ? _f : '',
    sortReverse: (_g = options.sortReverse) !== null && _g !== void 0 ? _g : false
  };
};

exports.getDefaultState = getDefaultState;

const setSortKeyAndReverseIfSameKeyReducer = (state, key) => Object.assign(Object.assign({}, state), {
  sortKey: key,
  sortReverse: key === state.sortKey ? !state.sortReverse : false
});

exports.setSortKeyAndReverseIfSameKeyReducer = setSortKeyAndReverseIfSameKeyReducer;

const setPageSizeReducer = (state, pageSize) => Object.assign(Object.assign({}, state), {
  pageNumber: 1,
  pageSize
});

exports.setPageSizeReducer = setPageSizeReducer;

const setPageNumberReducer = (state, pageNumber) => Object.assign(Object.assign({}, state), {
  pageNumber
});

exports.setPageNumberReducer = setPageNumberReducer;

const setFilterQueryReducer = (state, filterQuery) => Object.assign(Object.assign({}, state), {
  filterQuery,
  pageNumber: 1
});

exports.setFilterQueryReducer = setFilterQueryReducer;

const caseInsensitiveFilter = (state, item) => {
  return !state.filterQuery || state.filterQueryKeys.some(key => {
    var _a, _b;

    return (_b = (_a = item[key]) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(state.filterQuery.toLowerCase())) !== null && _b !== void 0 ? _b : false;
  });
};

exports.caseInsensitiveFilter = caseInsensitiveFilter;

const listStateReducer = (state, action) => {
  switch (action.type) {
    case types_1.ListStateReducerActions.setFilterQuery:
      return exports.setFilterQueryReducer(state, action.payload);

    case types_1.ListStateReducerActions.setPageNumber:
      return exports.setPageNumberReducer(state, action.payload);

    case types_1.ListStateReducerActions.setPageSize:
      return exports.setPageSizeReducer(state, action.payload);

    case types_1.ListStateReducerActions.setSortKeyAndReverseIfSameKey:
      return exports.setSortKeyAndReverseIfSameKeyReducer(state, action.payload);
  }
};

exports.listStateReducer = listStateReducer;

const useListState = options => {
  const [state, dispatch] = react_1.useReducer(exports.listStateReducer, exports.getDefaultState(options));

  const _caseInsensitiveFilter = react_1.useCallback(item => {
    return exports.caseInsensitiveFilter(state, item);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Only the specified values are required to be observed
  [state.filterQuery, state.filterQueryKeys]);

  const setFilterQuery = react_1.useCallback(filterQuery => {
    dispatch({
      payload: filterQuery,
      type: types_1.ListStateReducerActions.setFilterQuery
    });
  }, []);
  const setPageNumber = react_1.useCallback(pageNumber => {
    dispatch({
      payload: pageNumber,
      type: types_1.ListStateReducerActions.setPageNumber
    });
  }, []);
  const setPageSize = react_1.useCallback(pageSize => {
    dispatch({
      payload: pageSize,
      type: types_1.ListStateReducerActions.setPageSize
    });
  }, []);
  const setSortKeyAndReverseIfSameKey = react_1.useCallback(key => {
    dispatch({
      payload: key,
      type: types_1.ListStateReducerActions.setSortKeyAndReverseIfSameKey
    });
  }, []);
  return {
    caseInsensitiveFilter: _caseInsensitiveFilter,
    filterQuery: state.filterQuery,
    filterQueryKeys: state.filterQueryKeys,
    filterQueryMinLength: state.filterQueryMinLength,
    pageNumber: state.pageNumber,
    pageSize: state.pageSize,
    setFilterQuery,
    setPageNumber,
    setPageSize,
    setSortKeyAndReverseIfSameKey,
    sortKey: state.sortKey,
    sortReverse: state.sortReverse
  };
};

exports.useListState = useListState;